module.exports = __webpack_public_path__ + "img/user_name_icon.7c7b34df.svg";